import { ReactElement, Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './Options.module.scss';
import Printer from 'app/assets/icons/printer-pink.svg';

type CalendarProps = 'day' | 'week' | 'month' | 'year';

interface ChartDataFormat {
  name: string;
  Views: number;
}

type OptionProps = {
  isMain: boolean;
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  options: CalendarProps[];
  data: ChartDataFormat[];
};

function Options({
  activeTab,
  setActiveTab,
  options,
  isMain,
  data,
}: OptionProps): ReactElement {
  const handleTab = (range: string) => setActiveTab(range);

  const isActive = (range: string) => options.find((i) => i === range);

  const download = () => {
    const csv =
      'data:text/csv;charset=utf-8,' +
      data.map((e) => `${e.name}, ${e.Views}`).join('\n');
    const encodedUri = encodeURI(csv);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', '3Dapp_data.csv');
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className={styles.optionsWrapper}>
      <h2 className={styles.header}>
        {isMain ? (
          <FormattedMessage
            id="personalInsights.chart.header"
            defaultMessage="Total views for all tours"
          />
        ) : (
          <FormattedMessage
            id="personalInsights.chartModal.header"
            defaultMessage="Total views"
          />
        )}
      </h2>
      <div className={styles.toggleWrapper}>
        {isActive('day') && (
          <button
            className={`${activeTab === 'day' && styles.active}`}
            onClick={() => handleTab('day')}
          >
            <FormattedMessage
              id="personalInsights.chart.options.day"
              defaultMessage="Day"
            />
          </button>
        )}
        {isActive('week') && (
          <button
            className={`${activeTab === 'week' && styles.active}`}
            onClick={() => handleTab('week')}
          >
            <FormattedMessage
              id="personalInsights.chart.options.week"
              defaultMessage="Week"
            />
          </button>
        )}
        {isActive('month') && (
          <button
            className={`${activeTab === 'month' && styles.active}`}
            onClick={() => handleTab('month')}
          >
            <FormattedMessage
              id="personalInsights.chart.options.month"
              defaultMessage="Month"
            />
          </button>
        )}
        {isActive('year') && (
          <button
            className={`${activeTab === 'year' && styles.active}`}
            onClick={() => handleTab('year')}
          >
            <FormattedMessage
              id="personalInsights.chart.options.year"
              defaultMessage="Year"
            />
          </button>
        )}
      </div>
      <div className={styles.exportWrapper} onClick={download}>
        <span>
          <FormattedMessage
            id="personalInsights.chart.export"
            defaultMessage="Export"
          />
        </span>
        <img src={Printer} alt="Export CSV" />
      </div>
    </div>
  );
}

export default Options;
